export default class FieldHandler {
  constructor(element, fieldNameValue) {
    this.element = element
    this.fieldNameValue = fieldNameValue
    this.hiddenFieldsContainer = this.element.querySelector(".hidden-fields-container")
    this.fields = this.collectHiddenFields()
    this.multiple = this.element.multiple

    this.logHiddenFields()
  }

  handleFieldChange(value) {
    const fieldName = this.fieldNameValue

    if (this.hiddenFieldExists(fieldName, value)) {
      this.removeHiddenField(fieldName, value)
      console.log("Field removed")
    } else {
      this.addHiddenField(fieldName, value)
      console.log("Field added")
    }

    this.fields = this.collectHiddenFields()

    return this.fields
  }

  addHiddenField(fieldName, value) {
    const newField = document.createElement("input")
    newField.setAttribute("type", "hidden")
    newField.setAttribute("name", fieldName)
    newField.value = value
    this.hiddenFieldsContainer.appendChild(newField)
  }

  removeHiddenField(fieldName, value) {
    let fieldToRemove
    const existingFields = this.hiddenFieldsContainer.querySelectorAll(`input[name="${fieldName}"]`)
    Array.from(existingFields).forEach(field => {
      if (field.value === value) {
        fieldToRemove = this.hiddenFieldsContainer.removeChild(field)
      }
    })

    if (existingFields.length === 1) {
      this.addHiddenField(fieldName, "")
    }

    return fieldToRemove
  }

  hiddenFieldExists(fieldName, value) {
    const existingFields = this.hiddenFieldsContainer.querySelectorAll(`input[name="${fieldName}"]`)
    return Array.from(existingFields).some(field => field.value === value)
  }

  collectHiddenFields() {
    return this.hiddenFieldsContainer.querySelectorAll("input[type=\"hidden\"]")
  }

  logHiddenFields() {
    const fields = this.collectHiddenFields()
    const result = Array.from(fields).map(f => ({
      name: f.name,
      value: f.value
    }))
    console.log("Hidden fields:", result)
  }
}
